import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: () =>
                import ('./views/pc/Home.vue'),
            meta: 'home'
        },

        // {
        //     path: '/solution/:flag',
        //     name: 'solution',
        //     component: () =>
        //         import ('./views/pc/Solution.vue'),
        //     meta: 'solution'

        // },
        {
            path: '/newslist',
            name: 'newslist',
            component: () =>
                import ('./views/pc/Newslist.vue'),
            meta: 'newslist'
        },
        {
            path: '/newsdetail/:id',
            name: 'newsdetail',
            component: () =>
                import ('./views/pc/Newsdetail.vue'),
            meta: 'newsdetail'

        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: () =>
                import ('./views/pc/AboutUs.vue'),
            meta: 'aboutUs'
        },
        {
            path: '/hwtool',
            name: 'hwtool',
            component: () =>
                import ('./views/pc/HWTool.vue'),
            meta: 'service',
        },

        //底层核心平台
        {
            path: '/product/platform',
            name: 'platform',
            component: () =>
                import ('./views/pc/product/platform.vue'),
            meta: "product",
        },
        //恒为链
        {
            path: '/product/hwl',
            name: 'hwl',
            component: () =>
                import ('./views/pc/product/hwl.vue'),
            meta: "product",
        },
        //Co-Chain
        {
            path: '/product/CoChain',
            name: 'CoChain',
            component: () =>
                import ('./views/pc/product/CoChain.vue'),
            meta: "product",
        },
        //Data API
        {
            path: '/product/DataAPI',
            name: 'DataAPI',
            component: () =>
                import ('./views/pc/product/DataAPI.vue'),
            meta: "product",
        },
        //恒为BaaS平台
        {
            path: '/product/baas',
            name: 'baas',
            component: () =>
                import ('./views/pc/product/baas.vue'),
            meta: "product",
        },
        //区块链运维监控平台
        {
            path: '/product/operation',
            name: 'operation',
            component: () =>
                import ('./views/pc/product/operation.vue'),
            meta: "product",
        },
        //存证服务前置网关
        {
            path: '/product/gateway',
            name: 'gateway',
            component: () =>
                import ('./views/pc/product/gateway.vue'),
            meta: "product",
        },
        //资产数字化平台
        {
            path: '/product/digitization',
            name: 'digitization',
            component: () =>
                import ('./views/pc/product/digitization.vue'),
            meta: "product",
        },
        //数字资产工具包
        {
            path: '/product/toolkit',
            name: 'toolkit',
            component: () =>
                import ('./views/pc/product/toolkit.vue'),
            meta: "product",
        },
        //chrome插件下载
        {
            path: '/chromeExtension',
            name: 'chromeExtension',
            component: () =>
                import ('./views/pc/product/chromeExtension.vue'),
            meta: "product",
        },

        //2.1.1	区块链线上交易平台
        {
            path: '/solution/onlineTrad',
            name: 'onlineTrad',
            component: () =>
                import ('./views/pc/solution/onlineTrad.vue'),
            meta: "solution",
        },

        //2.1.2	区块链积分商城
        {
            path: '/solution/pointsMall',
            name: 'pointsMall',
            component: () =>
                import ('./views/pc/solution/pointsMall.vue'),
            meta: "solution",
        },

        //2.1.3	区块链证券交易平台
        {
            path: '/solution/asset',
            name: 'asset',
            component: () =>
                import ('./views/pc/solution/asset.vue'),
            meta: "solution",
        },

        //2.1.4	区块链清结算平台
        {
            path: '/solution/clear',
            name: 'clear',
            component: () =>
                import ('./views/pc/solution/clear.vue'),
            meta: "solution",
        },

        //2.1.5	区块链供应链金融平台
        {
            path: '/solution/supplyChain',
            name: 'supplyChain',
            component: () =>
                import ('./views/pc/solution/supplyChain.vue'),
            meta: "solution",
        },

        //2.2.1	区块链疫苗溯源平台
        {
            path: '/solution/vaccine',
            name: 'vaccine',
            component: () =>
                import ('./views/pc/solution/vaccine.vue'),
            meta: "solution",
        },

        //2.2.2	区块链处方流转平台
        {
            path: '/solution/medicalCare',
            name: 'medicalCare',
            component: () =>
                import ('./views/pc/solution/medicalCare.vue'),
            meta: "solution",
        },


        //2.2.3	区块链分级诊疗平台
        {
            path: '/solution/classification',
            name: 'classification',
            component: () =>
                import ('./views/pc/solution/classification.vue'),
            meta: "solution",
        },


        //2.3.1	区块链农渔产品溯源平台
        {
            path: '/solution/agriculture',
            name: 'agriculture',
            component: () =>
                import ('./views/pc/solution/agriculture.vue'),
            meta: "solution",
        },

        //2.4.1	区块链数据治理监管平台
        {
            path: '/solution/government',
            name: 'government',
            component: () =>
                import ('./views/pc/solution/government.vue'),
            meta: "solution",
        },

        //区块链农村三资监管平台
        {
            path: '/solution/countryside',
            name: 'countryside',
            component: () =>
                import ('./views/pc/solution/countryside.vue'),
            meta: "solution",
        },

        //加入我们
        {
            path: '/joinUs',
            name: 'joinUs',
            component: () =>
                import ('./views/pc/JoinUs.vue'),
            meta: "joinUs",
        },

        //-------手机端----------
        {
            path: '/mobile',
            name: 'mobileHome',
            component: () =>
                import ('./views/mobile/home.vue'),
            meta: {
                flag: 'mobileHome'
            }
        },
        // {
        //     path: '/mobile/service',
        //     name: 'mobileService',
        //     component: () =>
        //         import ('./views/mobile/service.vue'),
        //     meta: {
        //         flag: 'mobile'
        //     }
        // },
        // {
        //     path: '/mobile/solution/:flag',
        //     name: 'mobileSolution',
        //     component: () =>
        //         import ('./views/mobile/solution.vue'),
        //     meta: {
        //         flag: 'mobile'
        //     }
        // },
        {
            path: '/mobile/aboutus',
            name: 'mobileAboutus',
            component: () =>
                import ('./views/mobile/aboutus.vue'),
            meta: {
                flag: 'mobile'
            }
        },
        {
            path: '/mobile/newslist',
            name: 'mobileNewslist',
            component: () =>
                import ('./views/mobile/newslist.vue'),
            meta: {
                flag: 'mobile'
            }
        },
        {
            path: '/mobile/newsdetail/:id',
            name: 'mobileNewsdetail',
            component: () =>
                import ('./views/mobile/newsdetail.vue'),
            meta: {
                flag: 'mobile'
            }
        },
        {
            path: '/mobile/hwtool',
            name: 'mobileHwtool',
            component: () =>
                import ('./views/mobile/hwtool.vue'),
            meta: {
                flag: 'mobile'
            }
        },
        //底层核心平台
        {
            path: '/mobile/product/platform',
            name: 'mobilePlatform',
            component: () =>
                import ('./views/mobile/product/platform.vue'),
            meta: "mobile",
        },
        //恒为链
        {
            path: '/mobile/product/hwl',
            name: 'mobileHwl',
            component: () =>
                import ('./views/mobile/product/hwl.vue'),
            meta: "mobile",
        },
        //Co-Chain
        {
            path: '/mobile/product/CoChain',
            name: 'mobileCoChain',
            component: () =>
                import ('./views/mobile/product/CoChain.vue'),
            meta: "mobile",
        },
        //Data API
        {
            path: '/mobile/product/DataAPI',
            name: 'mobileDataAPI',
            component: () =>
                import ('./views/mobile/product/DataAPI.vue'),
            meta: "mobile",
        },
        //恒为BaaS平台
        {
            path: '/mobile/product/baas',
            name: 'mobileBaas',
            component: () =>
                import ('./views/mobile/product/baas.vue'),
            meta: "mobile",
        },
        //区块链运维监控平台
        {
            path: '/mobile/product/operation',
            name: 'mobileOperation',
            component: () =>
                import ('./views/mobile/product/operation.vue'),
            meta: "mobile",
        },
        //存证服务前置网关
        {
            path: '/mobile/product/gateway',
            name: 'mobileGateway',
            component: () =>
                import ('./views/mobile/product/gateway.vue'),
            meta: "mobile",
        },
        //资产数字化平台
        {
            path: '/mobile/product/digitization',
            name: 'mobileDigitization',
            component: () =>
                import ('./views/mobile/product/digitization.vue'),
            meta: "mobile",
        },
        //数字资产工具包
        {
            path: '/mobile/product/toolkit',
            name: 'mobileToolkit',
            component: () =>
                import ('./views/mobile/product/toolkit.vue'),
            meta: "mobile",
        },

        //2.1.1	区块链线上交易平台
        {
            path: '/mobile/solution/onlineTrad',
            name: 'mobileOnlineTrad',
            component: () =>
                import ('./views/mobile/solution/onlineTrad.vue'),
            meta: "mobile",
        },

        //2.1.2	区块链积分商城
        {
            path: '/mobile/solution/pointsMall',
            name: 'mobilePointsMall',
            component: () =>
                import ('./views/mobile/solution/pointsMall.vue'),
            meta: "mobile",
        },

        //2.1.3	区块链证券交易平台
        {
            path: '/mobile/solution/asset',
            name: 'mobileAsset',
            component: () =>
                import ('./views/mobile/solution/asset.vue'),
            meta: "mobile",
        },

        //2.1.4	区块链清结算平台
        {
            path: '/mobile/solution/clear',
            name: 'mobile',
            component: () =>
                import ('./views/mobile/solution/clear.vue'),
            meta: "mobile",
        },

        //2.1.5	区块链供应链金融平台
        {
            path: '/mobile/solution/supplyChain',
            name: 'mobileSupplyChain',
            component: () =>
                import ('./views/mobile/solution/supplyChain.vue'),
            meta: "mobile",
        },

        //2.2.1	区块链疫苗溯源平台
        {
            path: '/mobile/solution/vaccine',
            name: 'mobileVaccine',
            component: () =>
                import ('./views/mobile/solution/vaccine.vue'),
            meta: "mobile",
        },

        //2.2.2	区块链处方流转平台
        {
            path: '/mobile/solution/medicalCare',
            name: 'mobileMedicalCare',
            component: () =>
                import ('./views/mobile/solution/medicalCare.vue'),
            meta: "mobile",
        },


        //2.2.3	区块链分级诊疗平台
        {
            path: '/mobile/solution/classification',
            name: 'mobileClassification',
            component: () =>
                import ('./views/mobile/solution/classification.vue'),
            meta: "mobile",
        },


        //2.3.1	区块链农渔产品溯源平台
        {
            path: '/mobile/solution/agriculture',
            name: 'mobileAgriculture',
            component: () =>
                import ('./views/mobile/solution/agriculture.vue'),
            meta: "mobile",
        },

        //2.4.1	区块链数据治理监管平台
        {
            path: '/mobile/solution/government',
            name: 'mobileGovernment',
            component: () =>
                import ('./views/mobile/solution/government.vue'),
            meta: "mobile",
        },

        //区块链农村三资监管平台
        {
            path: '/mobile/solution/countryside',
            name: 'mobileCountryside',
            component: () =>
                import ('./views/mobile/solution/countryside.vue'),
            meta: "mobile",
        },
        //加入我们
        {
            path: '/mobile/joinUs',
            name: 'mobileJoinUs',
            component: () =>
                import ('./views/mobile/JoinUs.vue'),
            meta: "joinUs",
        },
        //chrome插件下载
        {
            path: '/mobile/chromeExtension',
            name: 'mobileChromeExtension',
            component: () =>
                import ('./views/mobile/product/chromeExtension.vue'),
            meta: "mobile",
        },

    ]
})